/**
 * Project help functions
 *
 */

import React from 'react';

const Helpers = {

	/**
	 * Returns a url with the correct url structure
	 *
	 * @param  {Array} url - the document link values
	 *
	 * @return {String} url
	 */

	linkResolver: url => {
		
		if (url.isBroken === true) {

			return undefined;
		}
		else {

			switch (url.type) {

				case 'home':
					return '/';

				case 'page':
					return '/' + url.uid;

				case 'contact':
					return '/' + url.uid;

				case 'article':
					return '/' + url.uid;

				case 'showcase':
					return '/work/' + url.uid;

				case undefined:
					return url.url;

				default:
					return '/';
			}
		}
	},

	/**
	 * Returns a public IP address
	 *
	 * @return {String}
	 */

	publicIP: async endpoint => {

		const response = await fetch(endpoint || 'https://api.ipify.org');
		const ip = response.text();

		return ip;
	},

	/**
	 * Returns an element's offset position
	 *
	 * @param  {String} id - the element id
	 *
	 * @return {Array}
	 */

	offset: id => {

		const field = document.getElementById(id);

		const bounding = field.getBoundingClientRect();
		const left = window.pageXOffset || document.documentElement.scrollLeft;
		const top = window.pageYOffset || document.documentElement.scrollTop;
		
		return { top: bounding.top + top, left: bounding.left + left };
	},

	/**
	 * Checks if an array of objcets is empty
	 *
	 * @param  {Array} value - the array to check
	 *
	 * @return {Boolean}
	 */

	isEmpty: items => {

		const value = items.filter(i => Object.values(i).filter(v => v !== null & v !== undefined).length > 0).length === 0 ? true : false;

		return value;
	},

	/**
	 * Checks for Array
	 *
	 * @param  {Array} value - the array to check
	 *
	 * @return {Boolean}
	 */

	isArray: value => {

		return value && typeof value === 'object' && value.constructor === Array;
	},

	/**
	 * Checks for Object
	 *
	 * @param  {Array} value - the array to check
	 *
	 * @return {Boolean}
	 */

	isObject: value => {

		return value && typeof value === 'object' && value.constructor === Object;
	},

	/**
	 * Removes a class name from an element
	 *
	 * @param  {Array} group - array of elements
	 * @param  {String} name - the class name to remove
	 * @param  {Boolean} parent - if parent element is target
	 *
	 */

	removeClass: (group, name, parent = false) => {

		[].forEach.call(group, function(el) { parent ? el.parentElement.classList.remove(name) : el.classList.remove(name) });
	},

	/**
	 * Adds a class name to an element
	 *
	 * @param  {Array} group - array of elements
	 * @param  {String} name - the class name to remove
	 * @param  {Boolean} parent - if parent element is target
	 *
	 */

	addClass: (group, name, parent = false) => {

		[].forEach.call(group, function(el) { parent ? el.parentElement.classList.add(name) : el.classList.add(name) });
	},

	/**
	 * Returns an object array with updated keys
	 *
	 * @param  {Array} data - the array to loop through
	 *
	 * @return {Array} ret
	 */

	renameObjectKeys: data => {

		if (data) {

			data.forEach(function(item) {

				const key = item.slice_type.includes('section') ? item.slice_type.substr(item.slice_type.lastIndexOf('_') + 1) + '_' : item.slice_type.substr(item.slice_type) + '_';
				
				Helpers.renameKeys(item.primary, key);
				Helpers.renameKeys(item.items);
			});
		}
	},

	/**
	 * Returns an object array with rewritten keys
	 *
	 * @param  {Array} arr - the array to loop through
	 * @param  {string} prefix - the string to replace
	 *
	 * @return {Array} ret
	 */

	renameKeys: (arr, prefix = '', ret = {}) => {
		
	 	if (Array.isArray(arr) === true) {

	 		return arr.map(obj => {

	 			Object.keys(obj).forEach(function(k) { obj[prefix ? k.replace(prefix, '') : k.split('_').pop()] = obj[k]; });

	 			return obj;
			})
	 	}
	 	else {

	 		Object.keys(arr).forEach(function(k) { arr[prefix ? k.replace(prefix, '') : k.split('_').pop()] = arr[k]; });
	 		
	 		return arr;
		}
	},

	/**
	 * Recursively cloning react children
	 *
	 * @param  {Array} children - children to loop through
	 * @param  {Object} conductor - children to loop through
	 * @param  {Array} components - supported react components
	 *
	 * @return {Array} children
	 */

	recursiveCloneChildren: (parent, children, conductor = {}, components = []) => {

		let types = components.length === 0 ? ['input', 'textarea', 'radio', 'checkbox', 'select'] : components;

		return React.Children.map(children, (child, i) => {

			if (React.isValidElement(child)) {
				
				const handler = types.includes(child.type.displayName ? child.type.displayName.toLowerCase() : '') ? Object.assign({ i: i, ref: el => parent.components[child.props.name ? child.props.name : parent.props.name + '-' + i] = el }, conductor) : {};

				handler.children = Helpers.recursiveCloneChildren(parent, child.props.children, conductor, types);

				return React.cloneElement(child, handler);
			}
			else {

				return child;
			}
		})
	}
}

export default Helpers




// WEBPACK FOOTER //
// ./src/utils/functions/helpers.js